webpackJsonp([1],Array(55).concat([
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);

var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bio__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_bio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_bio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Prayers__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Prayers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Prayers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_piligrim__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_piligrim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_piligrim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_air__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_air___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_air__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_token__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_token___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_token__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Historicsites__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Historicsites___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Historicsites__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_marker__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_marker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_marker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Signup__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_instructions__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_instructions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_instructions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Darshan__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Darshan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Darshan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Update__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_amartithi_schedule__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_amartithi_schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_amartithi_schedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_donations__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_donations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_donations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_amartithi_2021_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_amartithi_2021_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_amartithi_2021_vue__);



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/bio',
    name: 'bio',
    component: __WEBPACK_IMPORTED_MODULE_3__components_bio___default.a
  }, {
    path: '/Prayers',
    name: 'Prayers',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Prayers___default.a
  }, {
    path: '/air',
    name: 'air',
    component: __WEBPACK_IMPORTED_MODULE_6__components_air___default.a
  }, {
    path: '/piligrim',
    name: 'piligrim',
    component: __WEBPACK_IMPORTED_MODULE_5__components_piligrim___default.a
  }, {
    path: '/token',
    name: 'token',
    component: __WEBPACK_IMPORTED_MODULE_7__components_token___default.a
  }, {
    path: '/Historicsites',
    name: 'Historicsites',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Historicsites___default.a
  }, {
    path: '/marker/:infoText',
    name: 'marker',
    component: __WEBPACK_IMPORTED_MODULE_9__components_marker___default.a
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Login___default.a
  }, {
    path: '/signup',
    name: 'signup',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Signup___default.a
  }, {
    path: '/instruction',
    name: 'instruction',
    component: __WEBPACK_IMPORTED_MODULE_12__components_instructions___default.a
  }, {
    path: '/changeToken',
    name: 'Darshan',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Darshan___default.a
  }, {
    path: '/update',
    name: 'Update',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Update___default.a
  }, {
    path: '/schedule',
    name: 'Schedule',
    component: __WEBPACK_IMPORTED_MODULE_15__components_amartithi_schedule___default.a
  }, {
    path: '/donations',
    name: 'Donations',
    component: __WEBPACK_IMPORTED_MODULE_16__components_donations___default.a
  }, {
    path: '/amartithi-2021-live',
    name: 'Amartithi2021',
    component: __WEBPACK_IMPORTED_MODULE_17__components_amartithi_2021_vue___default.a
  }]
}));

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
  apiKey: 'AIzaSyB9wr3uuXYzuTxOG6NiNXp2Sb5PRkx0CEo',
  authDomain: 'meherbabaapp.com',
  databaseURL: 'https://meherbabaapp.firebaseio.com',
  projectId: 'meherbabaapp',
  storageBucket: 'meherbabaapp.appspot.com',
  messagingSenderId: '444912314665'
};
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);
/* let app = firebase.initializeApp(config)
let db = app.database()
let usersRef = db.ref('Users')

const messaging = firebase.messaging()
messaging.requestPermission()
.then(function () {
  // console.log('Permission Granted')
  return messaging.getToken()
})
.then((currentToken) => {
  // console.log(currentToken)
  db.ref('Users').once('value').then(function (snapshot) {
    var BreakException
    var exists = snapshot.val()
    var keys = Object.keys(exists)
    try {
      keys.forEach(function (key) {
        var User = exists[key]
        // console.log(User)
        if (User === currentToken) {
          throw BreakException
        }
      })
      usersRef.push(currentToken)
    } catch (e) {
      if (e === BreakException) {
        // console.log('Already Exists')
      }
    }
  })
})

messaging.onMessage(function (payload) {
  console.log('message Received', payload)
}) */

/* harmony default export */ __webpack_exports__["a"] = ({
  database: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database(),
  storage: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.storage()
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    user: null,
    loading: false,
    error: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    signUserUp: function signUserUp(_ref, payload) {
      var commit = _ref.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserIn: function signUserIn(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    clearError: function clearError(_ref3) {
      var commit = _ref3.commit;

      commit('clearError');
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(156)
  __webpack_require__(157)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(307),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(311),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_firebase__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_alert__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_social_sharing__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_social_sharing__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_social_sharing___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('alert', __WEBPACK_IMPORTED_MODULE_7__components_alert___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  firebase: {
    Trust: __WEBPACK_IMPORTED_MODULE_5__service_firebase__["a" /* default */].database.ref('Trust').orderByChild('created_at')
  },
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
  created: function created() {
    console.log(this.$route.path);
    if (this.$route.path === '/') {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        this.$router.push('/');
      } else if (window.navigator.platform !== 'Win16' && window.navigator.platform !== 'Win32' && window.navigator.platform !== 'Win64') {
        this.$router.push('/');
      } else {
        // console.log(window.navigator.platform)
        this.$router.push('/');
      }
    } else {
      this.$route.path;
    }
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      timeOut: false,
      dialog: false,
      sideNav: false
    };
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.timeOut = true;
    }, 1000);
  },

  computed: {
    menuItems: function menuItems() {
      var menuItems = [{ icon: 'home', title: 'Home', link: '/'
        // {icon: 'face', title: 'Sign up', link: '/signup'},
        // {icon: 'lock_open', title: 'Sign in', link: '/login'}
      }];
      if (this.userIsAuthenticated) {
        menuItems = [{ icon: 'home', title: 'Home', link: '/' },
        // {icon: 'receipt', title: 'Token', link: '/changeToken'},
        { icon: 'event_note', title: 'Update Events', link: '/update' }];
      }
      return menuItems;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    appShare: function appShare() {
      if (navigator.share) {
        navigator.share({
          title: 'AMBPPCT',
          text: 'Avatar Meher Baba Perpetual Public Charitable Trust (AMBPPCT) Official Mobile App',
          url: 'https://ambshare.page.link/Zi7X'
        }).then(function () {
          return console.log('Successful share');
        }).catch(function (error) {
          return console.log('Error sharing', error);
        });
      }
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Eventbus_eventbus_js__ = __webpack_require__(55);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      token: ''
    };
  },

  methods: {
    onTokenChange: function onTokenChange() {
      console.log(this.token);
      __WEBPACK_IMPORTED_MODULE_0__Eventbus_eventbus_js__["a" /* eventBus */].$emit('tokenChanged', this.token);
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDi8S0yBC6rcLTCgqxvRanYMMxT17CW14Y',
    v: '3.31'
    // libraries: 'places', //// If you need to use place input
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      center: { lat: 19.029908, lng: 74.719005 },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      items: [{ title: '1. The Tomb-Shrine, Samadhi of Avatar Meher Baba', avatar: '/static/doc-images/lists/samahdiSacred.jpg', link: '/marker/The%20Tomb-Shrine,%20Samadhi%20of%20Avatar%20Meher%20Baba' }, { title: '2. Meher Retreat', avatar: '/static/doc-images/lists/MeherRetreat.jpg', link: '/marker/Meher%20Retreat' }, { title: '3. The Dhuni of Meherabad', avatar: '/static/doc-images/lists/dhuni.jpg', link: '/marker/The%20Dhuni%20of%20Meherabad' }, { title: '4. The Original Well', avatar: '/static/doc-images/lists/Originalwell.jpg', link: '/marker/The%20Original%20Well' }, { title: '5. The Main Bungalow (also known as Mandali Hall)', avatar: '/static/doc-images/lists/MainBungulaow.jpg', link: '/marker/The%20Main%20Bungalow%20(also%20known%20as%20Mandali%20Hall)' }, { title: '6. The Tomb of Gilori Shah & The Neem Tree', avatar: '/static/doc-images/lists/GloriaShahTomb.jpg', link: '/marker/The%20Tomb%20of%20Gilori%20Shah%20&%20The%20Neem%20Tree' }, { title: '7. The Rahuri Cabin', avatar: '/static/doc-images/lists/rahuricabin.jpg', link: '/marker/The%20Rahuri%20Cabin' }, { title: '8. The Land', avatar: '/static/doc-images/lists/meherabadsign.jpg', link: '/marker/The%20Land' }],
      markers: [{
        position: { lat: 19.030994, lng: 74.714059 }, infoText: 'The Tomb-Shrine, Samadhi of Avatar Meher Baba', icon: '/static/doc-images/lists/loc/loc1.png'
      }, {
        position: { lat: 19.031159, lng: 74.714633 }, infoText: 'Meher Retreat', icon: '/static/doc-images/lists/loc/loc2.png'
      }, {
        position: { lat: 19.029584, lng: 74.718436 }, infoText: 'The Dhuni of Meherabad', icon: '/static/doc-images/lists/loc/loc3.png'
      }, {
        position: { lat: 19.029016, lng: 74.718350 }, infoText: 'The Original Well', icon: '/static/doc-images/lists/loc/loc4.png'
      }, {
        position: { lat: 19.028651, lng: 74.719369 }, infoText: 'The Main Bungalow (also known as Mandali Hall)', icon: '/static/doc-images/lists/loc/loc5.png'
      }, {
        position: { lat: 19.029163, lng: 74.718409 }, infoText: 'The Tomb of Gilori Shah & The Neem Tree', icon: '/static/doc-images/lists/loc/loc6.png'
      }, {
        position: { lat: 19.030101, lng: 74.719225 }, infoText: 'The Rahuri Cabin', icon: '/static/doc-images/lists/loc/loc7.png'
      }, {
        position: { lat: 19.029908, lng: 74.719015 }, infoText: 'The Land', icon: '/static/doc-images/lists/loc/loc8.png'
      }]
    };
  },

  methods: {
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      this.$router.push({ name: 'marker', params: { infoText: marker.infoText } });
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Eventbus_eventbus_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      token: '',
      tokenUrl: '',
      eventUrl: '',
      schedulePDF: '',
      amartithiUrl: '',
      aboutUsLink: 'https://app.meherjee.com/service-folder/WZXWBNHd1efZSRy1uGtv/0PS6iqyfg8UsnN2nV709',
      libraryUrl: 'https://avatarmeherbabatrust.org/index.php/online-library-2/',
      donationsUrl: 'https://ambppct-donations.herokuapp.com/', // 'https://ambppct.herokuapp.com/',
      generalDonationsUrl: 'https://rzp.io/l/ambppct', // 'https://ambppct-donations-gen.herokuapp.com/'
      amartithiLiveUrl: 'https://youtube.com/@Amartithi2012?si=PH0p-9GBgFKjo3mx', // 'https://www.youtube.com/@meherabadchannel/streams' // 'https://www.youtube.com/channel/UCeGuYMaYBeh5JY87rmcZE_A/live'
      liveUrl: 'https://www.youtube.com/@meherabadchannel/streams' // 'https://www.youtube.com/channel/UCeGuYMaYBeh5JY87rmcZE_A/live'
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.storage().ref().child('56th Amartithi Programme Timetable 2025.pdf').getDownloadURL().then(function (url) {
      _this.schedulePDF = url;
    });
    __WEBPACK_IMPORTED_MODULE_2__Eventbus_eventbus_js__["a" /* eventBus */].$on('tokenChanged', function (token) {
      console.log(token);
      _this.token = token;
      _this.updateToken();
    });
    // this.map()
    __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref('WeeklyUpdate/url').once('value').then(function (snapchot) {
      _this.eventUrl = snapchot.val();
      // location.href = snapchot.val()
    });
    // firebase.database().ref('50th Amartithi/url').once('value')
    //   .then((snapchot) => {
    //     this.amartithiUrl = snapchot.val()
    //   })
  },

  methods: {
    /* map () {
      firebase.database().ref('WeeklyUpdate/url').once('value')
      .then((snapchot) => {
        console.log(snapchot)
        // this.eventUrl = snapchot.val()
        location.href = snapchot.val()
      })
    }, */
    displayDetails: function displayDetails(id) {
      this.$router.push({ name: 'detail', params: { id: id } });
    },
    updateToken: function updateToken() {
      var _this2 = this;

      var storageRef = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.storage().ref();
      var file = this.token;
      var thisRef = storageRef.child(file + '.png');
      thisRef.getDownloadURL().then(function (url) {
        _this2.tokenUrl = url;
        var postUrl = {
          TokenNumber: file,
          url: _this2.tokenUrl
        };
        var updates = {};
        updates['Trust/-L23hfuuPh-POpu-oE03'] = postUrl;
        return __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database().ref().update(updates);
      });
    },
    getToken: function getToken() {
      if (navigator.onLine) {
        this.saveTokenToCache();
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["reduce"])(this.$root.Trust, function (Token, firebaseEntry) {
          Token[firebaseEntry['.key']] = {
            url: firebaseEntry['url']
          };
          return Token;
        }, {});
      } else {
        var token = JSON.parse(window.localStorage.getItem('Token'));
        return token;
      }
    },
    saveTokenToCache: function saveTokenToCache() {
      this.$root.$firebaseRefs.Trust.once('value', function (snapchot) {
        var cachedToken = {};
        snapchot.forEach(function (catSnapchot) {
          cachedToken[catSnapchot.key] = catSnapchot.val();
        });
        window.localStorage.setItem('Token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cachedToken));
      });
    },
    donations: function donations() {
      location.href = 'https://ambppct.herokuapp.com/';
    },
    live: function live() {
      location.href = 'https://youtu.be/j_mbhuKw9_I';
    }
  },
  mounted: function mounted() {
    this.saveTokenToCache();
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      e1: false,
      e2: true,
      password: '',
      email: ''
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignIn: function onSignIn() {
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: ''
    };
  },

  computed: {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : '';
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignUp: function onSignUp() {
      this.$store.dispatch('signUserUp', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { eventBus } from '../Eventbus/eventbus'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      file_name: '',
      loader: null,
      loading3: false,
      uploadTask: ''
    };
  },
  methods: {
    change: function change() {
      this.file_name = this.$refs.filename.files[0];
      this.uploadTask = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.storage().ref('/Weekly-Update');
      this.uploadTask.put(this.file_name).then(function (snapshot) {
        var url = snapshot.downloadURL;
        var updates = {};
        updates['WeeklyUpdate/url'] = url;
        return __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref().update(updates);
      }, function (error) {
        console.log(error);
      });
      // return this.$router.push('/')
    }
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    samadhi: function samadhi() {
      location.href = 'geo:<19.030994>,<74.714059>?q=<19.030994>,<74.714059>(THE AVATAR MEHER BABA SAMADHI, MEHERABAD)';
    },
    mpr: function mpr() {
      location.href = 'geo:<19.035537>,<74.706945>?q=<19.035537>,<74.706945>(MEHER PILGRIM RETREAT - MPR, MEHERABAD)';
    },
    mpc: function mpc() {
      location.href = 'geo:<19.0288018>,<74.7189833>?q=<19.0288018>,<74.7189833>(MEHER PILGRIM CENTER - MPC, MEHERABAD)';
    },
    hosteld: function hosteld() {
      location.href = 'geo:<19.028747>,<74.720657>?q=<19.028747>,<74.720657>(HOSTEL D, MEHERABAD)';
    }
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {}
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import firebase from 'firebase'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      e1: 0,
      schedulePDF: 'https://avatarmeherbabatrust.org/wp-content/uploads/2023/01/54th-Amartithi-2023-Program-Schedule.pdf'
    };
  },
  created: function created() {
    // firebase.storage().ref().child('FINAL-51st Amartithi Program 2020.pdf').getDownloadURL().then(url => {
    //   this.schedulePDF = url
    // })
  },

  methods: {}
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      e1: 0
    };
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      history: 'https://app.meherjee.com/service-content/WZXWBNHd1efZSRy1uGtv/lvy7isEamNP2WKGxpZmg',
      contactUs: 'https://app.meherjee.com/service-content/WZXWBNHd1efZSRy1uGtv/dAa6HKJoJ1ioiZtRxA6I',
      termsAndConditions: 'https://app.meherjee.com/service-content/WZXWBNHd1efZSRy1uGtv/zXb8WLVIsXoYe3A66GQJ',
      privacyPolicy: 'https://app.meherjee.com/service-content/WZXWBNHd1efZSRy1uGtv/eQudd4GYwWAiA1wPx9PI',
      refundNote: 'https://app.meherjee.com/service-content/WZXWBNHd1efZSRy1uGtv/lpuAzit1rTeKFlCy6YgX',
      old_razorpayDonationsUrl: 'https://pages.razorpay.com/ambppct',
      razorpayDonationsUrl: 'https://portal.meherbabaapp.com/service-portal' // 'https://rzp.io/l/ambppct'
    };
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: [{
        src: '/static/doc-images/Instructions/Picture1.jpg'
      }, {
        src: '/static/doc-images/Instructions/Picture2.jpg'
      }, {
        src: '/static/doc-images/Instructions/Picture3.jpg'
      }]
    };
  },

  created: function created() {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      this.$router.push('/Home');
    }
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    samadhi: function samadhi() {
      location.href = 'geo:<19.030994>,<74.714059>?q=<19.030994>,<74.714059>(The Tomb-Shrine, Samadhi of Avatar Meher Baba)';
    },
    retreat: function retreat() {
      location.href = 'geo:<19.031159>,<74.714633>?q=<19.031159>,<74.714633>(Meher Retreat)';
    },
    dhuni: function dhuni() {
      location.href = 'geo:<19.029584>,<74.718436>?q=<19.029584>,<74.718436>(The Dhuni of Meherabad)';
    },
    well: function well() {
      location.href = 'geo:<19.029016>,<74.718350>?q=<19.029016>,<74.718350>(The Original Well)';
    },
    bungalow: function bungalow() {
      location.href = 'geo:<19.028651>,<74.719369>?q=<19.028651>,<74.719369>(The Main Bungalow (also known as Mandali Hall))';
    },
    shah: function shah() {
      location.href = 'geo:<19.029163>,<74.718409>?q=<19.029163>,<74.718409>(The Tomb of Gilori Shah & The Neem Tree)';
    },
    cabin: function cabin() {
      location.href = 'geo:<19.030101>,<74.719225>?q=<19.030101>,<74.719225>(The Rahuri Cabin)';
    },
    land: function land() {
      location.href = 'geo:<19.029908>,<74.719015>?q=<19.029908>,<74.719015>(The Land)';
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      website_page: 'https://avatarmeherbabatrust.org/accommodation/'
    };
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    displayDetails: function displayDetails(id) {
      this.$router.push({ name: 'detail', params: { id: id } });
    },
    getToken: function getToken() {
      if (navigator.onLine) {
        this.saveTokenToCache();
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["reduce"])(this.$root.Trust, function (Token, firebaseEntry) {
          Token[firebaseEntry['.key']] = {
            url: firebaseEntry['url']
          };
          return Token;
        }, {});
      } else {
        var token = window.JSON.parse(localStorage.getItem('Token'));
        return token;
      }
    },
    saveTokenToCache: function saveTokenToCache() {
      this.$root.$firebaseRefs.Trust.once('value', function (snapchot) {
        var cachedToken = {};
        snapchot.forEach(function (catSnapchot) {
          cachedToken[catSnapchot.key] = catSnapchot.val();
        });
        window.localStorage.setItem('Token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cachedToken));
      });
    }
  },
  mounted: function mounted() {
    this.saveTokenToCache();
  }
});

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(301),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(308),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(303),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(313),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(298),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(316),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(151)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(300),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(305),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(317),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(310),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(302),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(299),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
  __webpack_require__(162)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(315),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79289cc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(319),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(304),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(306),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(314),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(309),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [(_vm.error) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', [_c('form', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Mail",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "password",
      "id": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "id": "confirmPassword",
      "type": "password",
      "rules": [_vm.comparePasswords]
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSignUp($event)
      }
    }
  }, [_vm._v("Sign up")])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-container', [_c('form', [_c('v-layout', [_c('input', {
    ref: "filename",
    attrs: {
      "type": "file",
      "accept": "*.pdf"
    }
  })]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    staticClass: "success",
    attrs: {
      "color": "blue-grey"
    },
    on: {
      "click": _vm.change
    }
  }, [_vm._v("\n                  Upload\n                  "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("cloud_upload")])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "piligrim"
    }
  }, [_c('v-app', [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v(" Reservations ")])])]), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Pilgrim Season")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', [_vm._v("1) The schedule of the opening and closing of the accommodation facilities Hostel D and Meher Pilgrim Retreat (MPR) at Meherabad is as follows:")]), _vm._v(" "), _c('ol', [_c('p', [_vm._v("a) Hostel D is open for pilgrims from 1 May. It remains closed for the summer from 15 March to 30 April.")])]), _vm._v(" "), _c('ol', [_c('p', [_vm._v("b) Meher Pilgrim Retreat (MPR) is open to pilgrims from 15 June. It remains closed for the summer from 1 May to 14 June.")])]), _vm._v(" "), _c('p', [_vm._v("2) Meherazad will be open for pilgrims till 14 March and will be closed from 15 March till 30 June. Meherazad will reopen for the following pilgrim season from 01 July.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Meher Baba’s Tomb:")]), _vm._v(" Open all year round")]), _vm._v(" "), _c('p', [_vm._v("For "), _c('strong', [_vm._v("'HOW & WHEN TO MAKE RESERVATIONS' alone,")]), _vm._v(" please use the content as in the Trust website page "), _c('a', {
    attrs: {
      "href": _vm.website_page,
      "target": "_blank"
    }
  }, [_vm._v("Accommodation – Avatar Meher Baba Perpetual Public Charitable Trust (avatarmeherbabatrust.org).")])])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("How & When to Make Reservations")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', [_vm._v("Reservations should be made by mail or email (email is faster and more convenient). Replies will be sent by mail or e-mail. Short-notice reservations can be requested by telephone but are not usually confirmed on the phone.")]), _vm._v(" "), _c('p', [_vm._v("Reservations should be made well in advance. Reservations for Meher Pilgrim Retreat are best made approximately six weeks before expected arrival. Please read the Pilgrim Season information above before continuing. Please scroll down for contact information.")]), _vm._v(" "), _c('p', [_vm._v("Please include the following information in all reservation requests:")]), _vm._v(" "), _c('p', [_vm._v("• Return address and telephone number."), _c('br'), _vm._v("\n                  • A few words of personal introduction, particularly for those who have not visited before."), _c('br'), _vm._v("\n                  • Names, dates of birth, and gender of those coming."), _c('br'), _vm._v("\n                  • Exact arrival date/time."), _c('br'), _vm._v("\n                  • Departure date/time from Meherabad."), _c('br'), _vm._v("\n                  • Nationality.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "151px",
      "width": "280px"
    },
    attrs: {
      "alt": "MPR",
      "src": "/static/doc-images/lists/htr1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Meher Pilgrim Retreat")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Reservations for Meher Pilgrim Retreat:     ")])]), _vm._v(" "), _c('p', [_vm._v("Email*:"), _c('a', {
    attrs: {
      "href": "mailto:pimco@ambppct.org"
    }
  }, [_vm._v("pimco@ambppct.org")]), _c('br'), _vm._v("\n                  Reservations: (0241) 254-8733"), _c('br'), _vm._v("\n                  From outside India:"), _c('br'), _vm._v("\n                  +91-241-254-8733")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "151px",
      "width": "280px"
    },
    attrs: {
      "alt": "",
      "src": "/static/doc-images/lists/htr2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Hostel \"D\"")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Reservations for Hostels or Dharmshala:  ")])]), _vm._v(" "), _c('p', [_vm._v("Email*:"), _c('a', {
    attrs: {
      "href": "mailto:jaibaba@ambppct.org"
    }
  }, [_vm._v("jaibaba@ambppct.org")]), _c('br'), _vm._v("\n                  phone: (+91) 241-2548777")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Check-in Procedure")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('strong', [_vm._v("Indian Citizens")])]), _vm._v(" with prior reservations can check-in at Meher Pilgrim Retreat between the hours of 10:00 am and 7:00 pm only. Visitors with reservations at Hostel D or Dharmshala may check in between 9:00 am and 10:00 pm. Persons arriving after these designated hours will have to make their own accommodation arrangements for that night in Ahmednagar.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('strong', [_vm._v("Non-Indians")])]), _vm._v(" are required to complete police registration at the Pilgrim Registration Office at the Meher Pilgrim Centre, lower Meherabad, before proceeding to Meher Pilgrim Retreat for check-in. Passport and two small photographs of each person are required. Hours for registration for those with confirmed reservations at Meherabad are 10:00 am to 6:00 pm.")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reach"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": "",
      "lg12": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h4', {
    staticStyle: {
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("Amarthithi-2021")])])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("Virtual Program")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('strong', [_vm._v("🌹Jai Meher Baba! 🌹")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Beloved Baba's 52nd Amartithi will be conducted online as announced.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin": "0"
    }
  }, [_c('i', [_vm._v("Start Time:")]), _vm._v(" 12:30 hrs IST, 30-Jan-2021.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('i', [_vm._v("End Time:")]), _vm._v(" 04:00 hrs IST, 01-Feb-2021.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "word-break": "break-word !important"
    }
  }, [_vm._v("Watch the program at: "), _c('a', {
    attrs: {
      "href": "https://avatarmeherbabatrust.org/index.php/avatar-meher-baba-virtual-amartithi-2021/",
      "target": "_blank"
    }
  }, [_vm._v("https://avatarmeherbabatrust.org/index.php/avatar-meher-baba-virtual-amartithi-2021/")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin": "0"
    }
  }, [_vm._v("Alternately, please navigate through these links:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "margin": "0",
      "word-break": "break-word !important"
    }
  }, [_vm._v("1) "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/c/AvatarMeherBabaMeherabadStreams/live",
      "target": "_blank"
    }
  }, [_vm._v("https://www.youtube.com/c/AvatarMeherBabaMeherabadStreams/live")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "word-break": "break-word !important"
    }
  }, [_vm._v("(broadcast may switch to "), _c('a', {
    attrs: {
      "href": "http://www.youtube.com/c/MeherChannel/live",
      "target": "_blank"
    }
  }, [_vm._v("http://www.youtube.com/c/MeherChannel/live")]), _vm._v(" in case of any disruption)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "word-break": "break-word !important"
    }
  }, [_vm._v("2) "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com//chirag.gehlot.395/videos/10157831724552196/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.facebook.com//chirag.gehlot.395/videos/10157831724552196/")])]), _vm._v(" "), _c('p', [_vm._v("🌹Avatar Meher Baba Ki Jai!🌹")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-container', [_c('form', [_c('v-layout', [_c('v-text-field', {
    attrs: {
      "name": "token",
      "label": "Token Number",
      "id": "token"
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onTokenChange($event)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-layout', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-end": "",
      "flexbox": ""
    }
  }, [(this.$route.params.infoText == 'The Tomb-Shrine, Samadhi of Avatar Meher Baba') ? _c('v-card', [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/samahdiSacred.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(this.$route.params.infoText))]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The most sacred place associated with Avatar Meher Baba is His Tomb-Shrine.\r\n\t\t\t\t\t\t   When He decided to move the Meher Ashram SCHOOL to the hill In June 1927,\r\n\t\t\t\t\t\t\tBaba chose this site to have a small hut of bamboo matting and steel sheets built. \r\n\t\t\t\t\t\t\tSoon after, He ordered a pit to be dug on this spot. \r\n\t\t\t\t\t\t\tThis pit was made more permanent with stone masonry, and small steps were built leading down into the crypt. \r\n\t\t\t\t\t\t\tA wooden cabin was constructed again over the crypt and a platform was built extending from the east wall of \r\n\t\t\t\t\t\t\tthe crypt so that Baba could greet visitors and gather with the ashram boys there. \r\n\t\t\t\t\t\t\tIn August 1927 Baba began spending His nights here, and on 10th November 1927,\r\n\t\t\t\t\t\t\t He began a 5½-month period of seclusion and fasting. \r\n\t\t\t\t\t\t\t During that time, He advanced many of the ashram boys spiritually, \r\n\t\t\t\t\t\t\t giving them profound inner experiences.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In 1929 the wooden walls were replaced with soft stone construction")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In 1938 the crypt was rebuilt into what is seen today with stones from the Post Office building.\r\n\t\t\t\t\t\t The symbols over the corners are the Zoroastrian flame, the Hindu temple, the Christian cross and \r\n\t\t\t\t\t\t the Muslim mosque. \r\n\t\t\t\t\t\t Later that year, under Baba’s direction, the Swiss artist Helen Dahm painted the interior murals.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Baba instructed that wherever He dropped His body, \r\n\t\t\t\t\t\tHis physical form was to be brought to Meherabad and interred in the Tomb. \r\n\t\t\t\t\t\tAnd so it was on 31st January 1969 that Beloved Baba's body, \r\n\t\t\t\t\t\tthe form that housed reality in illusion was brought from Meherazad to rest here for all time. \r\n\t\t\t\t\t\tBaba declared that 60 years after dropping His body, \r\n\t\t\t\t\t\tHis Tomb-Shrine would be a major place of pilgrimage for the world.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.samadhi
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v(" Walk to Samadhi")], 1)], 1)])])])], 1) : _vm._e(), _vm._v(" "), (this.$route.params.infoText == 'Meher Retreat') ? _c('v-card', [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/MeherRetreat.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(this.$route.params.infoText))]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The ground floor of this building was originally a double \r\n                    water tank constructed by the British Army to supply the POW camp down the hill. \r\n                    Baba stayed in seclusion in the tank rooms periodically during the 1920s, and 1930. \r\n                    In June 1927, the east and west doorways were cut through the thick rock walls. \r\n                    The East Room was used as a dormitory and \r\n                    the West Room as an assembly hall for the boys of the Meher Ashram School.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In 1933, the East Room became home to Baba’s close women mandali, \r\n                    where Mehera and the women were strictly sequestered, \r\n                    living a life of obedience, poverty and purity. \r\n                    From then until The New Life, Meher Retreat was used exclusively for women’s quarters. \r\n                    The upper story of the Retreat was built in 1938 as Baba expanded the women’s ashram. \r\n                    Baba’s meetings with His women mandali preceding the New Life took place here, \r\n                    after which the ashram was disbanded for the most part \r\n                    (with only Mansari and the Kaikobad family remaining on the Hill).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Later, the upper story and the West Room were used to quarter \r\n                    Western men during the 1954 Sahavas program. \r\n                    The West Room is now a museum and is open at regularly scheduled times. \r\n                    The South Room has become a library and the upper story is currently \r\n                    the Meherabad Hill Library exhibition and meeting space.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.retreat
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v(" Walk to Meher Retreat")], 1)], 1)])])])], 1) : _vm._e(), _vm._v(" "), (this.$route.params.infoText == 'The Dhuni of Meherabad') ? _c('v-card', [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/dhuni.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(this.$route.params.infoText))]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("On the evening of 10th November 1925, local villagers came to \r\n                    Baba pleading for rain to save them from an extreme drought. \r\n                    Baba ordered that a pit be dug and a fire lit. \r\n                    After some devotional music, Baba asked the villagers to depart quickly, \r\n                    but by the time they reached their homes, \r\n                    some were drenched by torrential rain, which lasted fifteen hours.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("On 12th December 1941, during one of His seclusion periods, \r\n                    Baba came down the Hill to the Dhuni. \r\n                    To maintain His seclusion, He had the area around the Dhuni curtained off. \r\n                    Allowing only four of the mandali to be present, one of them lit the Dhuni. \r\n                    One month later, on 12th January 1942, \r\n                    Baba had the Dhuni lit in honor of Upasni Maharaj who had recently dropped his body. \r\n                    From that day, Baba ordered that the Meherabad Dhuni be lit on the 12th of every month. \r\n                    The current platform around the pit was built in 1948. \r\n                    Meher Baba last attended the lighting of the Dhuni on 12th November 1955. \r\n                    At that time, He asked all attending to sacrifice some desire or shortcoming to the Dhuni. \r\n                    This custom has been followed since then.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.dhuni
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v(" Walk to Dhuni")], 1)], 1)])])])], 1) : _vm._e(), _vm._v(" "), (this.$route.params.infoText == 'The Original Well') ? _c('v-card', [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/Originalwell.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(this.$route.params.infoText))]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("During the mid-1920s, \r\n                    Meher Baba’s closest woman disciple, Mehera, \r\n                    would wash Baba's clothes on the large flat stones in the moat to the east of the Original Well. \r\n                    Once during the early days of Meherabad, after Gulmai washed Baba's feet, \r\n                    Baba had the wash water poured into the well and commented, \r\n                    “The water from this well will always be my prasad”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.well
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v(" Walk to Original Well")], 1)], 1)])])])], 1) : _vm._e(), _vm._v(" "), (this.$route.params.infoText == 'The Main Bungalow (also known as Mandali Hall)') ? _c('v-card', [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/MainBungulaow.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(this.$route.params.infoText))]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("THE MAIN BUNGALOW was erected in 1948 to provide a large, \r\n                    new meeting hall, which became known as Mandali Hall. \r\n                    The bungalow also provided living quarters for men mandali and a medical dispensary. \r\n                    Baba’s momentous meetings with His men mandali, \r\n                    preparing for the New Life, took place here, \r\n                    as well as several sahavas and darshan programs in the 1950s.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mohammed Mast lived in the hall for many years and \r\n                    later in a more private room at the south end of the building. \r\n                    Facing the bungalow from the west, Padri’s room can be seen just to the left of Mandali Hall. \r\n                    It is furnished much as it was when he was alive and gives an idea of the comparative comfort \r\n                    the mandali were allowed in the later years. \r\n                    This room also contained Padri’s homeopathic dispensary from which \r\n                    he treated many patients until his death in 1982.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.bungalow
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v(" Walk to Main Bungalow")], 1)], 1)])])])], 1) : _vm._e(), _vm._v(" "), (this.$route.params.infoText == 'The Tomb of Gilori Shah & The Neem Tree') ? _c('v-card', [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/GloriaShahTomb.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(this.$route.params.infoText))]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kaikhushru and Gulmai’s family was acquainted with Gilori Shah, \r\n                    a Mohammedan saint of Ahmednagar, who began urging them to give him a small plot on the property. \r\n                    Early in 1923, Kaikhushru agreed to his request. \r\n                    But when Gilori Shah informed his followers, they questioned his choice of this site for his tomb, \r\n                    since it was so desolate and distant from the city. \r\n                    He told them that soon \"the Great One” would come and make His abode here. \r\n                    Gilori Shah insisted that construction of his tomb be completed as soon as possible. \r\n                    On 4th May 1923, Meher Baba first came to this site with some of His disciples, walking from Ahmednagar. \r\n                    He sat beneath the neem tree, near the ready but still vacant tomb of Gilori Shah. \r\n                    An old carpenter who would become Baba's first disciple from Arangaon supplied \r\n                    Baba’s group with simple millet bread and a bucket to draw water from the well, \r\n                    which is behind the Engine Room. \r\n                    This was the water source for the property and later became known as the Original Well.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.shah
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v(" Walk to Tomb of Gilori Shah")], 1)], 1)])])])], 1) : _vm._e(), _vm._v(" "), (this.$route.params.infoText == 'The Rahuri Cabin') ? _c('v-card', [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/rahuricabin.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(this.$route.params.infoText))]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Now situated to the southeast of the Old Bungalow, \r\n                    THE RAHURI CABIN was named for the small town north of Ahmednagar where it was originally built. \r\n                    In 1936 Baba had an ashram for mad persons and a few masts in Rahuri, \r\n                    and this cabin served as His personal quarters there. \r\n                    By Baba’s order it was dismantled in 1937 and re-assembled at Meherabad. \r\n                    Baba then used it during periods of seclusion, and up until the late 1940s for interviews. \r\n                    Different masts were also accommodated here through the years.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.cabin
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v(" Walk to Rahuri Cabin")], 1)], 1)])])])], 1) : _vm._e(), _vm._v(" "), (this.$route.params.infoText == 'The Land') ? _c('v-card', [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/meherabadsign.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(this.$route.params.infoText))]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("THE PROPERTY THAT BECAME MEHERABAD had been developed as a \r\n                    British army POW camp during World War I. \r\n                    After the war the stock and equipment of the camp was auctioned off. \r\n                    The only structures left intact at the time were a post office building, a mess quarters, \r\n                    a bathroom building, a well near the road, \r\n                    and a large ground level water tank on the hill across the railway line. \r\n                    Except for the neem trees along the road, the land was barren and mostly unsuitable for agriculture. \r\n                    Kaikhushru and Gulmai Irani obtained this property in 1919. \r\n                    They were the parents of Rustom and Adi, two of Baba’s close men disciples.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.land
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v(" The Land")], 1)], 1)])])])], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('v-card-media', {
    attrs: {
      "src": "/static/doc-images/lists/samadhi.jpg",
      "height": "200px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-end": "",
      "flexbox": ""
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [
    [_c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'Donations'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/shake-hand.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Regular Donations to Trust\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'bio'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/bio.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Biography\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'air'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/how to reach.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  How to reach\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'piligrim'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "static/doc-images/lists/Accomdation.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Accommodation\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "href": _vm.liveUrl,
        "target": "_blank"
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/samadhi.jpg"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n\t\t\t\t\t\t\t\t\tAMB Tomb Shrine Virtual Darshan\n\t\t\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "to": {
          name: 'Prayers'
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/prayer.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Prayers\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "avatar": "",
        "href": _vm.libraryUrl,
        "target": "_blank"
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/digital-library-e-book.jpg"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Online Library\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_c('v-divider', {
      attrs: {
        "divider": "true",
        "inset": "true"
      }
    }), _vm._v(" "), _c('v-list-tile', {
      attrs: {
        "href": _vm.eventUrl,
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": "/static/doc-images/lists/events.png"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  Events\n                ")])], 1)], 1)], 1)]
  ], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-stepper', {
    staticStyle: {
      "background-color": "transparent"
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1"
    }
  }, [_vm._v("Name of step 1")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2"
    }
  }, [_vm._v("Name of step 2")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Name of step 3")])], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "padding": "0px",
      "height": "500px"
    },
    attrs: {
      "step": "1"
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)"
    }
  }, [_c('font', {
    attrs: {
      "face": "verdana"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v("Schedule")])])], 1)]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "450px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0001.jpg"
    }
  })])])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "grey",
    attrs: {
      "href": _vm.schedulePDF,
      "target": "_blank",
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    }
  }, [_c('v-icon', [_vm._v("cloud_download")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "2"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0002.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "3"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0003.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 4
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "4"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0004.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 5
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "5"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0005.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 6
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 4
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "6"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0006.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 7
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 5
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "7"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0007.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 8
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 6
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "8"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0008.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 9
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 7
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "9"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0009.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 10
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 8
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "10"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0010.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 11
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 9
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "11"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0011.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 12
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 10
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "12"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0012.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 13
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 11
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "13"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0013.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 14
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 12
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticStyle: {
      "height": "500px",
      "padding": "0px"
    },
    attrs: {
      "step": "14"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": "/static/pdf/FINAL-54th Amartithi Program 2023_page-0014.jpg"
    }
  })])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 13
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-toolbar', {
    staticStyle: {
      "background-color": "#5390cc"
    },
    attrs: {
      "dark": "",
      "fixed": ""
    }
  }, [(this.$router.currentRoute.name != 'Home') ? _c('router-link', {
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "0px"
    },
    attrs: {
      "to": "/",
      "tag": "span"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "45px",
      "color": "white",
      "margin-right": "-10px"
    }
  }, [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "/static/doc-images/lists/cropped-circle.png"
    }
  })]), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": "/",
      "tag": "span"
    }
  }, [_vm._v("Avatar Meher Baba")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "0.45em"
    },
    attrs: {
      "to": "/",
      "tag": "span"
    }
  }, [_vm._v("Avatar Meher Baba Perpetual Public Charitable Trust")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.$router.currentRoute.name == 'Home') ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right !important"
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("share")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Share With")]), _vm._v(" "), _c('v-card-text', [_c('social-sharing', {
    attrs: {
      "url": "https://ambshare.page.link/Zi7X",
      "title": "Avatar Meher Baba Perpetual Public Charitable Trust (AMBPPCT) Official Mobile App"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('v-layout', [_c('v-flex', {
            attrs: {
              "xs-4": ""
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('div', {
            staticStyle: {
              "text-align": "center",
              "padding-left": "5px"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icons/Fb.png",
              "height": "35px",
              "width": "35px"
            }
          }), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Facebook")])])])], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs-4": ""
            }
          }, [_c('network', {
            attrs: {
              "network": "sms"
            }
          }, [_c('div', {
            staticStyle: {
              "text-align": "center",
              "padding-left": "5px"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icons/message.png",
              "height": "35px",
              "width": "35px"
            }
          }), _c('br'), _vm._v(" "), _c('h5', [_vm._v("SMS")])])])], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs-4": ""
            }
          }, [_c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('div', {
            staticStyle: {
              "text-align": "center",
              "padding-left": "5px"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icons/whatsapp.png",
              "height": "35px",
              "width": "35px"
            }
          }), _c('br'), _vm._v(" "), _c('h5', [_vm._v("WhatsApp")])])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
            attrs: {
              "xs-4": ""
            }
          }, [_c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('div', {
            staticStyle: {
              "text-align": "center",
              "padding-left": "5px"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icons/email.png",
              "height": "35px",
              "width": "35px"
            }
          }), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Email")])])])], 1)], 1)], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-xs-only"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('v-btn', {
      key: item.title,
      attrs: {
        "flat": "",
        "to": item.link
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "dark": ""
      }
    }, [_vm._v(_vm._s(item.icon))]), _vm._v("\n        " + _vm._s(item.title) + "\n      ")], 1)
  }))], 1), _vm._v(" "), (_vm.timeOut) ? _c('main', [_c('router-view')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "mapheader"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 17
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.infoContent) + "\n\t\t\t\t  ")]), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "clickable": true,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          _vm.toggleInfoWindow(m, i)
        },
        "update:icon": function($event) {
          m.icon = $event
        }
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mapcontent"
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": "",
        "to": item.link
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })], 1)], 1)
  }))], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prayer"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v("Online Donations")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n              Easy way to send your donations to AMBPPC Trust using UPI, Netbanking and Cards.\n              ")])])], 1)], 1)], 1), _vm._v(" "), [_c('v-list', {
    staticStyle: {
      "background": "rgb(255, 255, 255, 0.5)"
    },
    attrs: {
      "one-line": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "href": _vm.razorpayDonationsUrl,
      "target": "_blank"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "/static/doc-images/lists/hand-credit-card.png"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('u', [_vm._v("AMBPPCT Online Donations")])]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticStyle: {
      "font-size": "0.85rem",
      "text-align": "center",
      "white-space": "normal"
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("(New Version with Monthly, Yearly &"), _c('br'), _vm._v("One time payment options)")])])], 1)], 1)], 1)], _vm._v(" "), [_c('v-list', {
    staticStyle: {
      "background": "rgb(255, 255, 255, 0.5)",
      "border-top": "1px solid"
    },
    attrs: {
      "one-line": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "href": _vm.old_razorpayDonationsUrl,
      "target": "_blank"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "/static/doc-images/lists/hand-credit-card.png"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('u', [_vm._v("AMBPPCT Online Donations")])]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticStyle: {
      "font-size": "0.85rem",
      "text-align": "center",
      "white-space": "normal"
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("(Old Version with One time payment option)")])])], 1)], 1)], 1)], _vm._v(" "), _c('v-container', {
    staticStyle: {
      "padding": "0 15px",
      "min-height": "0",
      "font-size": "0.75rem"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('p', [_vm._v("\n              The Trust is supported entirely by love-gifts from Meher Baba's followers around the world. With deep appreciation, the trustees salute the love for Beloved Baba that prompts His dear ones to financially contribute so that His Trust may continue to grow and develop. With ever-increasing activities and inflation all round, more donations are very much needed to support and sustain the activities of the Trust.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              The Trust has recently updated the donation App for greater convenience. In addition to one-time donations, you can now opt for monthly or yearly donations, providing greater flexibility in supporting the Trust objectives.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              All online donations will be acknowledged by email and by a receipt from the Trust sent by mail. Income Tax exemptions are available on donations to the AMBPPC Trust in India, according to the Income Tax law.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Tax exemption details: "), _c('br'), _vm._v("\n              Donations are eligible for benefit of deductions u/s. 80-G of the IT Act, 1961 vide Unique Registration Number : AAATA3271BF20213, dated 23-09-2021 From Assessment Year 2022-23 to 2026-27\n            ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "securityTerms",
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "href": _vm.history,
      "target": "_blank"
    }
  }, [_vm._v("About us")]), _vm._v("  \n              "), _c('a', {
    attrs: {
      "href": _vm.contactUs,
      "target": "_blank"
    }
  }, [_vm._v("Contact us")]), _vm._v("  \n              "), _c('a', {
    attrs: {
      "href": _vm.privacyPolicy,
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": _vm.termsAndConditions,
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v("  \n              "), _c('a', {
    attrs: {
      "href": _vm.refundNote,
      "target": "_blank"
    }
  }, [_vm._v("Refund Note")])])])], 1)], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    attrs: {
      "error": "",
      "dismissible": "",
      "value": true
    },
    on: {
      "input": _vm.onClose
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [(_vm.error) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', [_c('form', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Mail",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "password",
      "id": "password",
      "append-icon": _vm.e2 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e2 = !_vm.e2); },
      "type": _vm.e2 ? 'password' : 'text',
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSignIn($event)
      }
    }
  }, [_vm._v("Sign In")])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prayer"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v("  Prayers ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Arti and Prayers at Samadhi daily at 7:00 AM and 7:00 PM")])]), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Universal Prayer (Master’s Prayer)")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', [_vm._v("O Parvardigar — the Preserver and Protector of all!")]), _vm._v(" "), _c('p', [_vm._v("You are without Beginning, and without End,")]), _vm._v(" "), _c('p', [_vm._v("Non-dual, beyond comparison, and none\r\n\t\t\t\t\tcan measure You.")]), _vm._v(" "), _c('p', [_vm._v("You are without colour, without expression,\r\n\t\t\t\t\twithout form, and without attributes.")]), _vm._v(" "), _c('p', [_vm._v("You are unlimited and unfathomable,\r\n\t\t\t\t\tbeyond imagination and conception,\r\n\t\t\t\t\teternal and imperishable.")]), _vm._v(" "), _c('p', [_vm._v("You are indivisible; and none can see You,\r\n\t\t\t\t\tbut with Eyes Divine.")]), _vm._v(" "), _c('p', [_vm._v("You always were, You always are, and\r\n\t\t\t\t\tYou always will be;")]), _vm._v(" "), _c('p', [_vm._v("You are everywhere, You are in everything;\r\n\t\t\t\t\tand You are also beyond everywhere\r\n\t\t\t\t\tand beyond everything.")]), _vm._v(" "), _c('p', [_vm._v("You are in the firmament and in the depths;\r\n\t\t\t\t\tYou are manifest and unmanifest, on\r\n\t\t\t\t\tall planes and beyond all planes.")]), _vm._v(" "), _c('p', [_vm._v("You are in the three worlds, and also\r\n\t\t\t\t\tbeyond the three worlds;")]), _vm._v(" "), _c('p', [_vm._v("You are imperceptible and independent.")]), _vm._v(" "), _c('p', [_vm._v("You are the Creator, the Lord of lords,\r\n\t\t\t\t\tthe knower of all minds and hearts;")]), _vm._v(" "), _c('p', [_vm._v("You are omnipotent and omnipresent.")]), _vm._v(" "), _c('p', [_vm._v("You are Knowledge Infinite, Power Infinite,\r\n\t\t\t\t\tand Bliss Infinite.")]), _vm._v(" "), _c('p', [_vm._v("You are the Ocean of Knowledge, all-knowing,\r\n\t\t\t\t\tinfinitely knowing, the Knower of the past,\r\n\t\t\t\t\tthe present, and the future, and You are\r\n\t\t\t\t\tKnowledge Itself.")]), _vm._v(" "), _c('p', [_vm._v("You are all-merciful and eternally benevolent;")]), _vm._v(" "), _c('p', [_vm._v("You are the Soul of souls, the One with\r\n\t\t\t\t\tinfinite attributes.")]), _vm._v(" "), _c('p', [_vm._v("You are the Trinity of Truth, knowledge, and\r\n\t\t\t\t\tBliss,")]), _vm._v(" "), _c('p', [_vm._v("You are the Source of Truth, the Ocean of Love;")]), _vm._v(" "), _c('p', [_vm._v("You are the Ancient One, the Highest of the High;\r\n\t\t\t\t\tYou are Prabhu and Parameshwar, You are the\r\n\t\t\t\t\tBeyond-God, and the Beyond-Beyond God also,\r\n\t\t\t\t\tYou are Parabrahma, Allah, Elahi, Yezdan,\r\n\t\t\t\t\tAhuramazda, and God the Beloved.")]), _vm._v(" "), _c('p', [_vm._v("You are named Ezad — the only One\r\n\t\t\t\t\tworthy of worship.")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Repentance Prayer")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', [_vm._v("We repent O God most merciful, for all our sins;")]), _vm._v(" "), _c('p', [_vm._v("For every thought that was false or unjust or unclean;")]), _vm._v(" "), _c('p', [_vm._v("For every word spoken that ought not to have been spoken;")]), _vm._v(" "), _c('p', [_vm._v("For every deed done that ought not to have been done.")]), _vm._v(" "), _c('p', [_vm._v("We repent for every deed and word and thought")]), _vm._v(" "), _c('p', [_vm._v("Inspired by selfishness;")]), _vm._v(" "), _c('p', [_vm._v("And for every deed and word and thought inspired by hatred.")]), _vm._v(" "), _c('p', [_vm._v("We repent most specially for every lustful thought,")]), _vm._v(" "), _c('p', [_vm._v("And every lustful action;")]), _vm._v(" "), _c('p', [_vm._v("For every lie; for all hypocrisy;")]), _vm._v(" "), _c('p', [_vm._v("For every promise given, but not fulfilled")]), _vm._v(" "), _c('p', [_vm._v("And for all slander and backbiting.")]), _vm._v(" "), _c('p', [_vm._v("Most specially also, we repent for every action")]), _vm._v(" "), _c('p', [_vm._v("That has brought ruin to others;")]), _vm._v(" "), _c('p', [_vm._v("For every word and deed that has given others pain;")]), _vm._v(" "), _c('p', [_vm._v("And for every wish that pain should befall others.")]), _vm._v(" "), _c('p', [_vm._v("In your unbounded mercy, we ask you to forgive us, O God,")]), _vm._v(" "), _c('p', [_vm._v("For all these sins committed by us;")]), _vm._v(" "), _c('p', [_vm._v("And to forgive us for our constant failures")]), _vm._v(" "), _c('p', [_vm._v("To think and speak and act according to your will.")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Beloved God Prayer")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('p', [_vm._v("Beloved God, help us all to love You more and more, and more and more and still yet more, till we become worthy of union with You; and help us all to hold fast to Baba’s daaman till the very end.")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "darshan"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("Current Darshan Token Number")])])]), _vm._v(" "), _vm._l((_vm.getToken()), function(picture) {
    return _c('div', {
      key: picture.id,
      staticClass: "image-card"
    }, [_c('div', {
      staticClass: "image-card__picture",
      attrs: {
        "align": "center"
      }
    }, [_c('img', {
      attrs: {
        "src": picture.url
      }
    })])])
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n\t\t\t\t\t\tNOTE\n\t\t\t\t\t")]), _vm._v(" "), _c('ol', [_c('li', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" This number is only for information, do not use for darshan entry.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Your network must be working well and updating your app continuously for this function. Avatar Meher Baba Trust is not responsible for missing darshan due to bad network connection.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n\t\t\t\t\t\tATTENTION\n\t\t\t\t\t")]), _vm._v(" "), _c('ol', [_c('li', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Darshan of Beloved Avatar Meher Baba will be available inside the Tomb Shrine through a regulated queue designated specifically for this occasion.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("However, due to the influx of pilgrims during Amartithi, it is requested for the benefit of all pilgrims to take the least time possible for Darshan and to take Darshan only once on 31st January.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After collecting a single token with a number on it, each Pilgrim will be free to move about until the number on his/her token is announced and displayed on the signboards.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("THE PILGRIMS SHOULD JOIN THE QUEUE WHEN THEIR NUMBER IS DISPLAYED.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Please be alert because if your number has passed through the Darshan line and the next higher number has also passed, you will miss your turn and will require a new token.")])])], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reach"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": "",
      "lg12": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("How to Reach Meherabad")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Meherabad")]), _vm._v(" is located on Daund Road six kilometers outside the city of Ahmednagar, Maharashtra State, India. ")])]), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Travel By Air")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The nearest airports are at Pune and Aurangabad, both approximately two and one half hours from Ahmednagar by road. The nearest international airport is Mumbai, approximately five hours by road to Ahmednagar.")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Travel by Rail")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Located on the Daund/Manmad railway line, Ahmednagar is accessible by rail from many Indian cities, both to the north and south, including Delhi, Bangalore, and Hyderabad. Local rail service to/from Pune and Mumbai is not generally convenient as the trains are slow. ")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Travel by Car")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Buses and taxis reach Ahmednagar from Pune, Aurangabad, Sholapur, and Nasik. A direct road from Mumbai, which bypasses Pune, takes about five hours in light traffic.")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xl12": "",
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "d-flex": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xl6": "",
      "lg6": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.samadhi
    }
  }, [_c('v-icon', [_vm._v("location_on")]), _vm._v("Samadhi")], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xl6": "",
      "lg6": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.mpr
    }
  }, [_c('v-icon', [_vm._v("location_on")]), _vm._v("MPR")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xl12": "",
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "d-flex": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xl6": "",
      "lg6": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.mpc
    }
  }, [_c('v-icon', [_vm._v("location_on")]), _vm._v("MPC")], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xl6": "",
      "lg6": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.hosteld
    }
  }, [_c('v-icon', [_vm._v("location_on")]), _vm._v("Hostel-D")], 1)], 1)], 1), _vm._v(" "), _vm._v("\r\n\t\t\t \r\n\t\t\t"), _vm._v("\r\n\t\t\t \r\n\t\t\t")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bio"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-stepper', {
    staticStyle: {
      "background-color": "transparent"
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1"
    }
  }, [_vm._v("Name of step 1")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2"
    }
  }, [_vm._v("Name of step 2")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Name of step 3")])], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)"
    }
  }, [_c('font', {
    attrs: {
      "face": "verdana"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v(" Biography")])])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have come to sow the seed of love in your hearts so that, in spite of all superficial diversity which your life in illusion must experience and endure, the feeling of oneness through love is brought about amongst all the nations, creeds, sects and castes of the world.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("~ Meher Baba")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("AVATAR MEHER BABA")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("(1894-1969)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("  Baba's Family Portrait ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Meher Baba was born Merwan Sheriar Irani in Poona, India, on February 25, 1894, of Zoroastrian parents.  His father, Sheriar, was a true and respected seeker of God. Merwan had a normal childhood, and attended a Catholic high school. Later while attending Deccan College in 1913, he was summoned by Hazrat Babajan, an ancient Muslim saint who was one of the five Perfect Masters of the Age. After seven months, Babajan unveiled Merwan’s true state of God-consciousness.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Five Perfect Masters")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Eventually He was drawn to visit the other four perfect masters of the age including Sai Baba of Shirdi, who prostrated himself before Merwan shouting, “Parvardigar Ho!”  Sai sent Merwan to the Hindu Sadguru, Upasni Maharaj, who, over the next seven years, gave Merwan the divine knowledge He would need to fulfill His unique responsibility as Avatar. By that time a number of disciples from diverse backgrounds began to gather around Merwan, referring to Him as “Meher Baba”, which means “Compassionate Father.”  Meher Baba trained these early disciples over the coming years as He began to carry out His universal mission. Meher Baba and His close disciples maintained a lifestyle of purity and high moral standards. In May of 1923, Meher Baba first came here to Meherabad with some of those early disciples.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 4
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Baba Using Alphabet Board - May 19, 1932")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Within two years this place became a thriving colony whose residents followed a disciplined life, exemplary of Baba’s motto “Mastery in Servitude”. By Meher Baba’s direction, a hospital and dispensary, and schools were established providing a variety of free services to the needy local population, irrespective of caste, creed, or religion.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("On July 10, 1925 Meher Baba began His great long silence here, which He maintained for the rest of His life. This was not undertaken as a spiritual exercise but rather, a limitation He assumed for the benefit of humanity. For many years He communicated by pointing to the letters on an alphabet board. In 1954, He deepened His Silence by giving up the board, & communicating through His unique, eloquent hand gestures and expressions. However, in His Silence Meher Baba gave unparalleled discourses and explanations concerning the spiritual Truths of the universe.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 5
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "5"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Meher Baba, New York - 1932")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Through the years, Meher Baba was unconcerned about the opposition to Him from various religious communities: “I belong to no religion. Every religion belongs to me. My own personal religion is of my being the Ancient Infinite One, and the religion I teach to all is of love for God.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Beginning in 1931 Meher Baba began a series of world travels contacting thousands and ‘laying cables’ for His spiritual work.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 6
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 4
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "6"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Baba Feeding a Mast")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("An important part of Meher Baba’s work through the years was to personally contact and serve hundreds of advanced pilgrims on the spiritual path called “masts”. These are advanced souls who have become spiritually intoxicated from direct awareness of God. Baba traveled many thousands of miles to remote places throughout the Indian sub-continent working to advance the masts spiritually and to engage them in His work which would benefit humanity.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 7
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 5
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "7"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Meher Baba with New\r\n\t\t\t\t\t\t\t   Life Companions - 1949")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("1949 Meher Baba went with a few companions on what He called ‘the New Life’ of complete renunciation, absolute helplessness & sole reliance on God. By living this New Life, which included wandering and begging phases, Meher Baba became the ordinary seeker on behalf of all humanity, and along with His companions, re-established the clear path to God.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 8
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 6
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "8"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Baba in Switzerland - 1952")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("During the 1950s Meher Baba travelled three more times to the West and visited Centres in America and Australia that were prepared for Him there. In 1952 in America, and in 1956 near Satara, India, Meher Baba was injured in two serious automobile accidents. He explained that in each advent the Avatar takes on physical and spiritual suffering as part of the work He does for humanity.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 9
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 7
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "9"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Meher Baba, Mass Darshan - 1965")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("During the mid-1950s Meher Baba travelled to different parts of India to give mass darshan programs to over a million people, sowing His love deep in their hearts. Through the 1960s Meher Baba continued to do His Universal Spiritual Work, often fasting in strict seclusion just as He had done since the early years of His mission.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 10
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 8
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "10"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" Meher Baba's Tomb (Samadhi) Meherabad, India")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The purpose of Meher Baba’s life was to fulfill His work of giving the great ‘spiritual push’ to the universe.  In July of 1968 Meher Baba announced that He had completed His work 100% to His satisfaction, but His health was shattered, and on 31st January 1969, Meher Baba dropped His physical form to live eternally in the hearts of all who love Him. In keeping with His directive, His body was brought to Meherabad and placed in His Tomb-Shrine.  Today, Meher Baba’s Tomb is a site of world pilgrimage to thousands who come to pay homage to the Avatar of the Age.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 9
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('ol', [_c('li', [_vm._v("Open your mobile chrome browser and type http://meherbabaapp.com/ ")]), _vm._v(" "), _c('li', [_vm._v("Follow the below steps to install Mobile App.")])])])], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "align": "center",
      "src": "/static/doc-images/Instructions/ambppct final.gif",
      "alt": "This is an animated gif image, but it does not move"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ })
]),[124]);


// WEBPACK FOOTER //
// static/js/app.97b5947192e5d89e47e5.js